import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AppItem } from './AppItem';
import { MyBrizAppIcon } from '../../commons/icons/MyBrizApp';
import { BrizTvIcon } from '../../commons/icons/BrizTv';
import { isBrizTvFeatureEnabled } from '../../../constants/configuration';

export const OurApps: FC = () => {
  const { t, i18n } = useTranslation();
  const apps = [
    {
      title: t('ourApps.myBrizPersonalAccountInSmartphone'),
      googleLink: process.env.REACT_APP_MY_BRIZ_ANDROID
        ? `${process.env.REACT_APP_MY_BRIZ_ANDROID}&hl=${i18n.language}`
        : '',
      appleLink: process.env.REACT_APP_MY_BRIZ_APPLE ? `${process.env.REACT_APP_MY_BRIZ_APPLE}?l=${i18n.language}` : '',
      icon: <MyBrizAppIcon />,
    },
  ];

  if (isBrizTvFeatureEnabled) {
    apps.push({
      title: t('ourApps.brizTvOnSmartphoneAndTv'),
      googleLink: process.env.REACT_APP_BRIZ_TV_ANDROID
        ? `${process.env.REACT_APP_BRIZ_TV_ANDROID}&hl=${i18n.language}`
        : '',
      appleLink: process.env.REACT_APP_BRIZ_TV_APPLE || '',
      icon: <BrizTvIcon />,
    });
  }

  return (
    <div className="our-apps">
      <article className="our-apps__title home-title">{t('home.ourApps')}</article>
      <div className="our-apps__apps">
        {apps.map((el) => {
          return (
            <AppItem
              key={el.title}
              title={el.title}
              googleLink={el.googleLink}
              appleLink={el.appleLink}
              icon={el.icon}
            />
          );
        })}
      </div>
    </div>
  );
};
